import { RouteObject } from "react-router-dom"
//sms
import SmsService from '../components/messageCenter/sms/SmsService';
import SmsNotificationConfig from '../components/messageCenter/sms/SmsNotificationConfig';
import SmsManage from '../components/messageCenter/sms/SmsManage';
//wx
import WxSubscribeMessageType from '../components/messageCenter/wx/subscribe/WxSubscribeMessageType';
import WxSubscribeMessage from '../components/messageCenter/wx/subscribe/WxSubscribeMessage';
import WxSubscribeMessageUser from '../components/messageCenter/wx/subscribe/WxSubscribeMessageUser';

import WxSubscribeMessageV2Type from '../components/messageCenter/wx/subscribe/WxSubscribeMessageV2Type';
import WxSubscribeMessageV2User from '../components/messageCenter/wx/subscribe/WxSubscribeMessageV2User';
import WxSubscribeMessageV2 from '../components/messageCenter/wx/subscribe/WxSubscribeMessageV2';

//客服信息
import CustomerServiceOperator from '../components/messageCenter/wx/customerService/CustomerServiceOperator';
import CustomerService from '../components/messageCenter/wx/customerService/CustomerService';

//邮件
import EmailSupplier from '../components/messageCenter/email/EmailSupplier';
import EmailTemplate from '../components/messageCenter/email/EmailTemplate';
import Emails from '../components/messageCenter/email/Emails';

const messageRouters: RouteObject[] = [
    //sms
    {
        path: "/smsService",
        element: <SmsService />,
    },
    {
        path: "/smsNotificationConfig",
        element: <SmsNotificationConfig />,
    },
    {
        path: "/smsManage",
        element: <SmsManage />,
    },
    //wx
    {
        path: "/wxSubscribeMessageType",
        element: <WxSubscribeMessageType />,
    },
    {
        path: "/wxSubscribeMessage",
        element: <WxSubscribeMessage />,
    },
    {
        path: "/wxSubscribeMessageUser",
        element: <WxSubscribeMessageUser />,
    },
    {
        path: "/wxSubscribeMessageV2Type",
        element: <WxSubscribeMessageV2Type />,
    },
    {
        path: "/wxSubscribeMessageV2User",
        element: <WxSubscribeMessageV2User />,
    },
    {
        path: "/wxSubscribeMessageV2",
        element: <WxSubscribeMessageV2 />,
    },
    {
        path: "/customerServiceOperator",
        element: <CustomerServiceOperator />,
    },
    {
        path: "/customerService",
        element: <CustomerService />,
    },
    {
        path: "/emailSupplier",
        element: <EmailSupplier />,
    },
    {
        path: "/emailTemplate",
        element: <EmailTemplate />,
    },
    {
        path: "/emails",
        element: <Emails />,
    },
]

export default messageRouters;